
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAUxecMoztl-5ORJ9wRR0RPk9RdT850sok",
    authDomain: "techastroriver.firebaseapp.com",
    databaseURL: "https://techastroriver-default-rtdb.firebaseio.com",
    projectId: "techastroriver",
    storageBucket: "techastroriver.appspot.com",
    messagingSenderId: "1092131395327",
    appId: "1:1092131395327:web:18e0fb520125984b959eca",
    measurementId: "G-9Y4REVGNYG"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
